import { render, staticRenderFns } from "./ApplicationView.vue?vue&type=template&id=56a2b010&scoped=true&"
import script from "./ApplicationView.vue?vue&type=script&lang=ts&"
export * from "./ApplicationView.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationView.vue?vue&type=style&index=0&id=56a2b010&lang=scss&scoped=true&"
import style1 from "./ApplicationView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2b010",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
